import { render, staticRenderFns } from "./HighchartColumn.vue?vue&type=template&id=52510856&scoped=true&"
import script from "./HighchartColumn.vue?vue&type=script&lang=js&"
export * from "./HighchartColumn.vue?vue&type=script&lang=js&"
import style0 from "./HighchartColumn.vue?vue&type=style&index=0&id=52510856&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52510856",
  null
  
)

export default component.exports